import {find, findMany, dataset, on} from '../helpers';

findMany('.js-toggle').forEach((el) => {
    on(
        'click',
        () => {
            const target = find(`.${dataset(el, 'target')}`);

            target.classList.toggle('hidden');
            el.classList.toggle('is-active');
        },
        el,
    );
});
